<div class="bloqueNotFound noCliente_element_to_target" *ngIf="!renderNewClient">
  <p class="card-text" [innerHTML]="'cli.noClient.intro' | translate:{ nif: person.identifier}"></p>
  <a class="btn btn-primary" (click)="createClientClicked()"><i class="fa fa-pencil"></i><span translate>cli.noClient.noClientBt</span></a>
</div>
<div class="card infoEmpresaEdit" *ngIf="renderNewClient">
  <div class="card-body">
    <h3 translate>cli.noClient.title</h3>
    <form>
      <div class="input-group row">
        <label class="col-md-3 col-12" translate>cli.noClient.legalLabel</label>
        <div class="col-md-9 col-12 text-justify">
          <div [innerHTML]="'cli.noClient.legal' | translate:{ nif: person.identifier, person: person.tradeName}"></div><div>
            <label class="form-check-label">
              <input type="checkbox" (change)="isAcceptedUseConditions = !isAcceptedUseConditions" name="isAceptedUseConditions" class="form-check-input">
              <span translate>cli.noClient.legalOk</span>
            </label>
          </div>
        </div>
      </div>
      <hr>

      <div class="botonera">
        <div class="offset-md-3 offset-0 col-md-9 col-12">
          <button class="btn btn-secondary" (click)="onCancelClicked()" type="button" translate>cli.noClient.legalBtCancel</button>
          <button class="btn btn-primary" [disabled]="!isAcceptedUseConditions" (click)="saveClient()" type="button" translate><i class="fa fa-download"></i> cli.noClient.legalBtSingSave</button>
          <div id="div_sign_error" class="notaPie destacado bajoBoton"></div>
        </div>
      </div>
    </form>
    <form name="firma" id="firma">
      <input hidden id="firma_xml" name="firma[xml]" [(ngModel)]="xml"  />
      <input hidden id="firma_formularioweb" name="firma[formularioweb]"  />
      <input hidden id="firma_firma_formularioweb" name="firma[firma_formularioweb]" />
      <div hidden>
        <button hidden type="submit" id="firma_submit" name="firma[submit]" translate>cli.noClient.legalBtSing</button>
      </div>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-manager/client/cli-client/cli-client.component.html